'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLevels = function IoLevels(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.1 7.7c0.9 0.4 1.4 1.3 1.4 2.3s-0.5 1.9-1.4 2.3v21.5c0 0.7-0.6 1.2-1.3 1.2s-1.2-0.5-1.2-1.2v-21.8c-0.6-0.4-1.1-1.1-1.1-2s0.5-1.6 1.1-2v-1.7c0-0.8 0.5-1.3 1.2-1.3s1.3 0.5 1.3 1.3v1.4z m7.5 15.2c0.7 0.5 1.2 1.2 1.2 2.1s-0.5 1.6-1.2 2.1v6.7c0 0.7-0.6 1.2-1.3 1.2s-1.2-0.5-1.2-1.2v-6.6c-0.8-0.4-1.3-1.3-1.3-2.2s0.5-1.8 1.3-2.2v-16.5c0-0.8 0.5-1.3 1.2-1.3s1.3 0.5 1.3 1.3v16.6z m7.5-10.2c0.8 0.5 1.2 1.3 1.2 2.2s-0.4 1.7-1.2 2.2v16.7c0 0.7-0.6 1.2-1.3 1.2s-1.2-0.5-1.2-1.2v-16.7c-0.8-0.5-1.3-1.2-1.3-2.2s0.5-1.7 1.3-2.2v-6.4c0-0.8 0.5-1.3 1.2-1.3s1.3 0.5 1.3 1.3v6.4z m8.7 17.2c0 1-0.4 1.7-1.2 2.2v1.7c0 0.7-0.6 1.2-1.3 1.2s-1.2-0.5-1.2-1.2v-1.7c-0.8-0.5-1.3-1.2-1.3-2.2s0.5-1.7 1.3-2.2v-21.4c0-0.8 0.5-1.3 1.2-1.3s1.3 0.5 1.3 1.3v21.4c0.8 0.5 1.2 1.3 1.2 2.2z' })
        )
    );
};

exports.default = IoLevels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/levels.js
// module id = 2361
// module chunks = 0